import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  CHECKIN_DELETE_COMPANION_RESULT_STORE_NAME,
  CheckinDeleteCompanionResultState,
} from './checkin-delete-companion-result.state';

/** Select CheckinDeleteCompanionResult State */
export const selectCheckinDeleteCompanionResultState = createFeatureSelector<CheckinDeleteCompanionResultState>(
  CHECKIN_DELETE_COMPANION_RESULT_STORE_NAME
);

/** Select CheckinDeleteCompanionResult isPending status */
export const selectCheckinDeleteCompanionResultIsPendingStatus = createSelector(
  selectCheckinDeleteCompanionResultState,
  (state) => !!state.isPending
);

/** Select CheckinDeleteCompanionResult isFailure status */
export const selectCheckinDeleteCompanionResultIsFailureStatus = createSelector(
  selectCheckinDeleteCompanionResultState,
  (state) => !!state.isFailure
);
